// extracted by mini-css-extract-plugin
export var numpadContainer = "_ml-1";
export var phoneButton = "_ml-0";